'use strict';

import { appendParamToURL, removeParamFromURL } from 'Util/urlUtils';

class VZAdditionalProduct extends HTMLElement {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['visible'];
    }

    connectedCallback() {
        this.notifyProductCard = this.notifyProductCard.bind(this);
        this.quantityField = this.querySelector('.js-quantity-field');
        this.quantityField.addEventListener('fieldUpdated', this.notifyProductCard);

        // Execute immediately, since this element will be replaced (and have it's value be reset)
        // when the vz-quantity-selector element is updated.
        this.notifyProductCard();
    }

    notifyProductCard() {
        const value = this.quantityField.value;
        const productId = this.getAttribute('product-id');

        const element = this.querySelector('[data-url]');
        let url = element.getAttribute('data-url');

        // Get current additional products and quantities from URL or attributes
        const additionalProductsParam = this.getAttribute('additional-products') || '';
        const additionalProductsQtyParam = this.getAttribute('additional-products-qty') || '';

        const productIds = additionalProductsParam ? additionalProductsParam.split(',') : [];
        const quantities = additionalProductsQtyParam ? additionalProductsQtyParam.split(',') : [];

        // Find or add this product in the arrays
        const productIndex = productIds.indexOf(productId);

        if (Number(value) > 0) {
            // Add or update product
            if (productIndex === -1) {
                productIds.push(productId);
                quantities.push(value);
            } else {
                quantities[productIndex] = value;
            }
        } else if (productIndex !== -1) {
            // Remove product if quantity is 0
            productIds.splice(productIndex, 1);
            quantities.splice(productIndex, 1);
        }

        // Update URL with new arrays
        url = removeParamFromURL(url, 'additionalproducts');
        url = removeParamFromURL(url, 'additionalproductsqty');

        if (productIds.length > 0) {
            url = appendParamToURL(url, 'additionalproducts', productIds.join(','));
            url = appendParamToURL(url, 'additionalproductsqty', quantities.join(','));
        }

        element.setAttribute('data-url', url);

        // Update parent vz-product-card attributes so getUrlFromAttributes() picks them up
        const productCard = this.closest('vz-product-card');
        if (productCard) {
            if (productIds.length > 0) {
                productCard.setAttribute('additional-products', productIds.join(','));
                productCard.setAttribute('additional-products-qty', quantities.join(','));
            } else {
                productCard.removeAttribute('additional-products');
                productCard.removeAttribute('additional-products-qty');
            }
        }

        // Keep form payload in sync with the card attributes used by variation updates.
        const additionalProductsInput = document.getElementById('additionalProducts');
        if (additionalProductsInput) {
            const additionalProducts = productIds.map((id, index) => ({
                pid: id,
                quantity: quantities[index]
            }));
            additionalProductsInput.value = JSON.stringify(additionalProducts);
        }

        // Dispatch custom event to notify other components
        const groupSummary = document.querySelector('vz-group-summary');
        if (groupSummary) {
            groupSummary.dispatchEvent(
                new CustomEvent('additionalProductChange', {
                    detail: {
                        productId: productId,
                        value: value
                    }
                })
            );
        }
    }
}

export default window.customElements.get('vz-additional-product') || VZAdditionalProduct;
if (!window.customElements.get('vz-additional-product')) {
    window.customElements.define('vz-additional-product', VZAdditionalProduct);
}
